module.exports = __webpack_public_path__ + "static/talk-5-c91e4052c34868b4f34a3385c755a8ba.png";